import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './QuickBooksCallback.css';
import { QUICKBOOKS_BASE_URL } from '../components/api';

const QuickBooksCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing QuickBooks connection...');
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const realmId = urlParams.get('realmId');

        if (!code || !realmId) {
          setStatus('error');
          setMessage('Missing required parameters from QuickBooks');
          return;
        }

        // Get auth token
        const token = localStorage.getItem('authToken');
        if (!token) {
          setStatus('error');
          setMessage('Please log in to complete the connection');
          return;
        }

        // Send callback data to backend
        const response = await fetch(`${QUICKBOOKS_BASE_URL}callback/`, {
          method: 'POST',
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            code: code,
            realmId: realmId,
            state: state,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          setStatus('success');
          setMessage(`Successfully connected to ${data.company.company_name}!`);
          
          // Redirect to profile after 3 seconds
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } else {
          const errorData = await response.json();
          setStatus('error');
          setMessage(errorData.error || 'Failed to complete QuickBooks connection');
        }
      } catch (error) {
        console.error('QuickBooks callback error:', error);
        setStatus('error');
        setMessage('Network error. Please try again.');
      }
    };

    handleCallback();
  }, [navigate]);

  const handleRetry = () => {
    window.location.href = '/';
  };

  return (
    <div className="quickbooks-callback">
      <div className="callback-container">
        <div className="callback-header">
          <h1>QuickBooks Integration</h1>
        </div>
        
        <div className="callback-content">
          {status === 'processing' && (
            <div className="processing">
              <div className="spinner"></div>
              <p>{message}</p>
            </div>
          )}
          
          {status === 'success' && (
            <div className="success">
              <div className="success-icon">✓</div>
              <h2>Connection Successful!</h2>
              <p>{message}</p>
              <p>Redirecting to your profile...</p>
            </div>
          )}
          
          {status === 'error' && (
            <div className="error">
              <div className="error-icon">✗</div>
              <h2>Connection Failed</h2>
              <p>{message}</p>
              <button onClick={handleRetry} className="retry-btn">
                Go to Profile
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickBooksCallback;
